'use client';

import { memo, useEffect } from 'react';
import { setCookie, getCookie, deleteCookie } from 'cookies-next';
import { useSearchParams } from 'next/navigation';
import { useReferralCode } from '@/api/hooks/referral-code/useReferralCode';
import { COOKIE_KEYS } from '@/utils/constants';
import useQueryParams from '@/hooks/useQueryParams';
const ReferralCode = () => {
  const searchParams = useSearchParams();
  const queryParams = useQueryParams();
  const onSuccessHandler = () => {
    deleteCookie(COOKIE_KEYS.referral.code);
    queryParams.removeQueries(['ref']);
  };
  const {
    mutate
  } = useReferralCode({
    onSuccess: onSuccessHandler
  });
  const code = searchParams.get('ref') ?? getCookie(COOKIE_KEYS.referral.code);
  useEffect(() => {
    if (typeof window !== 'undefined' && code) {
      const hasAccessToken = !!getCookie(COOKIE_KEYS.auth.accessToken);
      if (hasAccessToken) {
        mutate({
          code
        });
      } else {
        setCookie(COOKIE_KEYS.referral.code, code, {
          maxAge: 259200
        }); // 3 days
        queryParams.removeQueries(['ref']);
      }
    }
  }, [code]);
  return null;
};
export default memo(ReferralCode);